const Logout = p => {
  localStorage.clear();
  // p.history('/');
  return Logout;
};

export default Logout;
